import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
  TrackByFunction,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core'
import { NgbPopover } from '@ng-bootstrap/ng-bootstrap'
import { dropRight } from 'lodash-es'
import { Breadcrumb } from './breadcrumb'

interface CollapsedCrumbs {
  collapsed: Breadcrumb[]
  current: Breadcrumb[]
}

@Component({
  selector: 'ftr-breadcrumbs-display',
  templateUrl: 'breadcrumbs-display.component.html',
  styleUrls: ['breadcrumbs-display.component.css'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class BreadcrumbsDisplayComponent {
  @ViewChild('popOver') popover: NgbPopover

  breadcrumbs = input.required<Breadcrumb[]>()
  collapse = input<boolean>()
  clampLeaf = input<boolean>()
  // We clamp the link (e.g. overflow with ellipses, and show a tooltip) if that link would wrap to two lines
  // otherwise. This value is dynamically calculated using bounding rects in the parent component.
  clampLink = input<boolean>()
  // This parameter handles the edge case where a link crumb won't wrap (e.g. it's one word) but is otherwise longer
  // than the space the default flex rules would apply. It's dynamically calculated using bounding rects in the parent
  // component.
  expandLink = input<boolean>()

  private focusTimeout: ReturnType<typeof setTimeout>

  protected collapsedBreadcrumbs = computed(() => {
    const crumbs = this.breadcrumbs()
    return {
      collapsed: dropRight(crumbs.slice(0), 2),
      current: crumbs.slice(-2),
    } as CollapsedCrumbs
  })

  onFocusIn(): void {
    clearTimeout(this.focusTimeout)
  }

  // Hide popover when focus is lost
  onFocusOut(): void {
    this.focusTimeout = setTimeout(() => {
      if (this.popover) {
        this.popover.close()
      }
    }, 0)
  }

  handleDropdownOnEnter(): void {
    this.focusDropdownLink()
  }

  trackBy: TrackByFunction<Breadcrumb> = (index: number) => {
    return index
  }

  private focusDropdownLink(): void {
    const breadcrumbDropDownLinks = Array.from(document.querySelectorAll<HTMLElement>('.breadcrumbs-dropdown__link'))
    const breadcrumbDropDownLink = breadcrumbDropDownLinks.at(0)

    if (breadcrumbDropDownLink) {
      breadcrumbDropDownLink.focus()
    }
  }
}
